import { __assign } from "tslib";
import { designApiRelativePath, createDesignApi } from './index';
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from './../../../test-utils';
export var createDesignApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createDesignApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetDesign: function () {
            return createFakeGetResponder(fakeHttp, "" + designApiRelativePath);
        },
        whenUpdateDesign: function (dto) {
            return createFakePutResponder(fakeHttp, "" + designApiRelativePath)(dto.data);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map